export const ICONS_ALIASES = {
  arrowRight: 'arrowRight',
  arrowTwoToneLeft: 'arrowTwoToneLeft',
  starCheck: 'starCheck',
  sadCircle: 'sadCircle',
};
